import React from 'react';
import { connect } from "react-redux";

import { fetchProfile, setToken } from '../../redux/actions/user';
import { getAuthJSON } from '../../util/util';
import { Link } from 'react-router-dom';
import { GlobalState, ReduxAction } from '../../redux/types';
import { BravoUser } from '../../bravoTypes';
import { urls } from '../../constants';
import './contextProviders.css';

// Wrapping a component in `Authorized` will force the user to the login page, 
// with the appropriate referrer, if the user has not authenticated. 

type AuthProps = {
    token?: string | null;
    profile?: BravoUser;
    updateUserProfile: (profile: BravoUser | null) => void;
    setToken: (token: string | null) => void;
}


const mapStateToProps = (state:GlobalState) => ({
    token: state.user.token,
    profile: state.user.profile,
});

const mapDispatchToProps = (dispatch:(a:ReduxAction)=>void) => ({
    updateUserProfile: (profile:BravoUser | null) => dispatch(fetchProfile(profile)),
    setToken: (token:string|null)=>dispatch(setToken(token))
});

export default function withAuth(WrappedComponent: typeof React.Component, requireAuth=true) {
    return connect(mapStateToProps, mapDispatchToProps)(
        class AuthWrapper extends React.Component<AuthProps> {
        constructor(props:AuthProps) {
            super(props);
            this.fetchUserState = this.fetchUserState.bind(this);
            this.refreshProfile = this.refreshProfile.bind(this);
        }

        componentDidMount() {
            this.fetchUserState();
        }

        componentDidUpdate() {
            this.fetchUserState();
        }

        fetchUserState() {
            const { token, profile } = this.props;
            if (token && profile) {
                return;
            } else if (token) {
                this.refreshProfile();
            }
        }

        async refreshProfile() {
            const { updateUserProfile, token, setToken } = this.props;
            if(token !== undefined && token !== null){
                try{
                    const profile = await getAuthJSON<BravoUser>(urls.currentUser, token);
                    updateUserProfile(profile);
                } catch (e) {
                    setToken(null);
                }
            }
        }

        render() {
            const { token, profile, updateUserProfile, ...props } = this.props;
            if (token && profile) {
                return <WrappedComponent {...{token, profile, ...props }} refreshProfile={this.refreshProfile}/>
            } else if (token) {
                return <div id="loading"></div>
            } else if (requireAuth){
                return <Link to='/login'>This view requires that you log in.</Link>
            } else {
                return <WrappedComponent {...{token, profile, ...props }} refreshProfile={this.refreshProfile}/>
            }
        }
    });
};

